(function() {
    angular.module('ngmvac').controller('webpayController', webpayController);
     webpayController.$inject = ['$scope'];
    function webpayController($scope){
        var vm = this;

        vm.metodopago = '';
        vm.monto = '';
        vm.moneda = '';
    }
})();